import React from "react";
import Hero from "@/components/home/Hero";
import BenefitMarquee from "@/components/home/BenefitMarquee";
import { ShopByCategory, ProductTabs, Storytelling, Testimonials } from "@/components/home/HomeSections";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <BenefitMarquee />
      <ShopByCategory />
      <ProductTabs />
      <Storytelling />
      <Testimonials />
    </div>
  );
}
